export default __webpack_public_path__ + "static/media/avatar.0fc8d6d5.svg";